import React, { useState } from "react";
import { useCircle } from "circle/circle.selectors";
import { toast } from "lib-core";


export const useOpenCreateModal = (): [boolean, React.Dispatch<React.SetStateAction<boolean>>] => {
  const circle = useCircle();

  const [openModal, setOpenModalState] = useState(false);

  const setOpenModal: React.Dispatch<React.SetStateAction<boolean>> = (v) => {
    if (circle && circle.status) {
      toast("Circle is not approved", { type: "error" });
      return;
    }
    setOpenModalState(v);
  };
  return [openModal, setOpenModal];
};
